module.exports = __webpack_public_path__ + "img/step-1-image.fae87a2e.jpg";